/** `03 Oct 2026`, the way every Reports row dates a report; `null` when there is none. */
export function formatCollectionDate(value: string | null): string | null {
  if (!value) return null;
  return new Date(value).toLocaleDateString("en-SG", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
}
